module.exports = __webpack_public_path__ + "static/media/WebText_Difficulty_Baby.cd3745e8.png";